'use strict';

(function () {
  'use strict';

  angular.module('msWriteOnly', ['msUtility', 'msCore', 'msSleep', 'msOnboarding']).config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('sleepdiary', {
      url: '/sleepdiary?token&day&loginUrl',
      templateUrl: 'writeonly/pages/sleep-entry.html',
      controller: 'WriteOnlySleepEntryCtrl',
      data: {
        noAuth: true,
        pageTitle: 'pageTitles.sleep'
      },
      controllerAs: '$ctrl',
      onEnter: ['$stateParams', 'msAuth', 'eventTrackingSvc', function ($stateParams, msAuth, eventTrackingSvc) {
        if (msAuth.isLoggedIn()) {
          var day = $stateParams.day ? '?day=' + $stateParams.day : '';
          window.location = '/v/sleep/entry' + day;
        } else {
          // Partial logout removes the token from the cookies but leaves
          // it in the service until a page refresh or nav
          msAuth.setToken($stateParams.token);
          msAuth.partialLogout();
          eventTrackingSvc.fireEvent('engagement', 'unauthenticatedVisit', 'sleepDiary');
        }
      }]
    });
  }]).run(['eventTrackingSvc', function (eventTrackingSvc) {
    eventTrackingSvc.init();
    eventTrackingSvc.registerEventListeners();
  }]).constant('context', 'writeonly');
})();